import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DinamicTitle } from '../utils/DinamicTitle';
import { http } from '../config/http';
import logoKD from '../assets/logo_kd.png';
import { IconEye, IconEyeOff, IconLock, IconUser } from '@tabler/icons-react';
import { useTheme } from '../context/ThemeContext';
import { useMasterData } from '../context/MasterDataContext';

export default function Login() {
  const { theme } = useTheme();
  const { refreshMasterData } = useMasterData() || {};
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPasswor] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  function handleOnChange(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  const { username, password } = formData;

  async function handleSubmitLogin(e) {
    e.preventDefault();
    const dataLogin = {
      username,
      password,
    };
    setIsLoading(true);
    try {
      const response = await http.post(`auth/login`, dataLogin);
      const token = response?.data?.access_token;

      // 1. Simpan seluruh data sesi ke localStorage TERLEBIH DAHULU
      localStorage.setItem('token', token);
      localStorage.setItem('user_id', response?.data?.user?.id || '');
      localStorage.setItem('cabang_id', response?.data?.user?.cabang_id || response?.data?.user?.cabang?.id || '');
      localStorage.setItem('toko', response?.data?.user?.cabang?.nama_cabang || '');
      localStorage.setItem('name', response?.data?.user?.name || '');
      localStorage.setItem('role', response?.data?.user?.role?.[0] || '');
      localStorage.setItem('tipe_surat', parseInt(response?.data?.user?.cabang?.tipe_surat) || 0);
      localStorage.setItem('id_brankas', response?.data?.brankas?.[0]?.id || '');

      // 2. Muat ulang seluruh Master Data Context dengan token baru
      window.dispatchEvent(new CustomEvent('login-success', { detail: { access_token: token } }));
      if (refreshMasterData) {
        try {
          await refreshMasterData(token);
        } catch (err) {
          console.warn('Gagal memuat master data saat login:', err);
        }
      }

      // 3. Notifikasi sukses dan navigasi ke halaman utama
      toast.success('Login sukses', { autoClose: 600 });
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.error || error.response?.data?.message || 'Login gagal', { autoClose: 1000 });
    } finally {
      setIsLoading(false);
    }
  }
  DinamicTitle('Login || Komaladewi');

  const tahunCopy = new Date().getFullYear();

  return (
    <div className="min-h-screen flex items-center justify-center sm:p-4 md:p-8 bg-white sm:bg-[#fdfbf7] dark:bg-slate-950 transition-colors duration-500">
      <div className="w-full h-screen sm:h-auto max-w-[950px] flex flex-col lg:flex-row bg-white dark:bg-slate-900 sm:rounded-[2rem] sm:shadow-[0_8px_30px_-10px_rgba(0,0,0,0.08)] dark:shadow-2xl overflow-hidden min-h-[580px]">

        {/* Left Side Branding */}
        <div
          className="hidden lg:flex w-full lg:w-[45%] p-10 flex-col items-center justify-center relative text-center"
          style={{ background: 'linear-gradient(145deg, #d3833d 0%, #aa5b16 100%)' }}
        >
          <div className="relative z-10 flex flex-col items-center">
            {/* Logo */}
            <div className="w-[140px] h-[140px] rounded-full p-2 bg-gradient-to-br from-[#f8dfad] via-[#dfb175] to-[#c78846] shadow-2xl mb-8 relative">
              <div className="absolute inset-2 rounded-full border border-white/40 z-0"></div>
              <div className="w-full h-full rounded-full bg-[#fdfbf7] flex items-center justify-center p-3 relative z-10 shadow-inner">
                <img src={logoKD} alt="Logo" className="w-full h-full object-contain drop-shadow" />
              </div>
            </div>

            <h1 className="text-[2rem] font-bold text-white mb-6 drop-shadow-sm tracking-wide">
              Komala Dewi
            </h1>

            <div className="w-[1px] h-4 bg-white/20 mb-6"></div>

            <p className="text-white/80 text-sm leading-relaxed max-w-[280px] font-medium">
              Aplikasi Transaksi Penjualan dan Pembelian Emas dan<br />Perhiasan <span className="font-bold text-[#f7d9a1]">Bersurat</span>
            </p>

            {/* <div className="flex justify-center items-center gap-2 mt-8">
              <div className="w-1.5 h-1.5 rounded-full bg-[#f7d9a1]/70"></div>
              <div className="w-8 h-[1px] bg-[#f7d9a1]/30"></div>
            </div> */}
          </div>
        </div>

        {/* Right Side Form */}
        <div className="w-full lg:w-[55%] px-6 pt-16 pb-8 sm:p-12 lg:p-14 flex flex-col justify-center bg-white dark:bg-slate-900 border-l-0 lg:border-l border-slate-100 dark:border-slate-800 relative min-h-screen sm:min-h-0">

          <div className="mb-10 text-left">
            <h2 className="text-[36px] sm:text-[32px] font-extrabold text-[#1f2937] dark:text-white tracking-tight leading-none mb-2">Log In Komala Dewi</h2>
            <p className="text-[#64748b] dark:text-slate-400 text-[16px] sm:text-[15px]">Silahkan masuk ke akun Anda</p>
          </div>

          <form onSubmit={handleSubmitLogin} className="space-y-6">

            {/* Username Field */}
            <div className="space-y-2">
              <label className="flex items-center gap-2 text-[15px] sm:text-sm font-bold text-[#64748b] dark:text-slate-300">
                <IconUser size={20} className="sm:w-[18px] sm:h-[18px] text-[#e58a00]" stroke={2.5} />
                Username
              </label>
              <input
                type="text"
                name="username"
                value={username}
                onChange={handleOnChange}
                required
                autoComplete="off"
                placeholder="Masukkan Username"
                className="w-full h-[56px] sm:h-[52px] px-4 rounded-[14px] sm:rounded-xl border-[2px] border-[#f7d9a1] bg-white dark:bg-slate-900 text-[#1e293b] dark:text-slate-100 text-[16px] sm:text-sm focus:outline-none focus:ring-4 focus:ring-[#f7d9a1]/30 focus:border-[#d98b41] transition-all placeholder:text-[#cbd5e1] dark:placeholder:text-slate-500 font-medium"
              />
            </div>

            {/* Password Field */}
            <div className="space-y-2">
              <label className="flex items-center gap-2 text-[15px] sm:text-sm font-bold text-[#64748b] dark:text-slate-300">
                <IconLock size={20} className="sm:w-[18px] sm:h-[18px] text-[#e58a00]" stroke={2.5} />
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={password}
                  onChange={handleOnChange}
                  required
                  autoComplete="off"
                  placeholder="Masukkan Password"
                  className="w-full h-[56px] sm:h-[52px] px-4 rounded-[14px] sm:rounded-xl border-[2px] border-[#f7d9a1] bg-white dark:bg-slate-900 text-[#1e293b] dark:text-slate-100 text-[16px] sm:text-sm focus:outline-none focus:ring-4 focus:ring-[#f7d9a1]/30 focus:border-[#d98b41] transition-all placeholder:text-[#cbd5e1] dark:placeholder:text-slate-500 font-medium"
                />
                <button
                  type="button"
                  onClick={() => setShowPasswor(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-[#94a3b8] hover:text-[#475569] dark:hover:text-slate-300 transition-colors"
                >
                  {showPassword ? <IconEye size={24} className="sm:w-5 sm:h-5 text-[#64748b]" /> : <IconEyeOff size={24} className="sm:w-5 sm:h-5 text-[#64748b]" />}
                </button>
              </div>
            </div>

            {/* Checkbox Lihat Password */}
            {/* <div className="flex items-center gap-3 sm:gap-2 pt-2 pb-4 sm:pb-2">
              <div className="relative flex items-center justify-center w-5 h-5 sm:w-4 sm:h-4">
                <input
                  type="checkbox"
                  id="showPass"
                  checked={showPassword}
                  onChange={() => setShowPasswor(!showPassword)}
                  className="peer w-full h-full appearance-none rounded-[4px] border-[1.5px] border-[#94a3b8] checked:border-transparent bg-transparent checked:bg-[#e58a00] focus:ring-0 outline-none cursor-pointer transition-all shrink-0"
                />
                <svg
                  className="absolute w-3 h-3 sm:w-2.5 sm:h-2.5 text-white pointer-events-none opacity-0 peer-checked:opacity-100 transition-opacity"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="3.5"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <label htmlFor="showPass" className="text-[15px] sm:text-[13px] font-medium text-[#64748b] dark:text-slate-400 cursor-pointer select-none">
                Lihat Password
              </label>
            </div> */}

            <button
              type="submit"
              disabled={isLoading}
              className="w-full h-[56px] sm:h-[52px] bg-[#e58a00] hover:bg-[#d17e00] text-white font-bold text-[16px] sm:text-[15px] rounded-[14px] mt-2 sm:mt-0 transition-all duration-300 flex items-center justify-center gap-2 shadow-[0_8px_20px_-6px_rgba(229,138,0,0.5)] hover:shadow-[#e58a00]/40 dark:shadow-[#e58a00]/10 disabled:opacity-70 disabled:shadow-none"
            >
              {isLoading ? (
                <div className="w-5 h-5 border-[3px] border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                <>
                  <span>Log In</span>
                  <svg className="w-[20px] h-[20px] sm:w-[18px] sm:h-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </>
              )}
            </button>

          </form>

          {/* Footer inside right panel */}
          <div className="mt-auto sm:mt-10 pt-16 sm:pt-10 text-center pb-4 sm:pb-0">
            <div className="w-[85%] mx-auto h-[1px] bg-[#f1f5f9] dark:bg-slate-800 mb-6 sm:mb-6"></div>
            <p className="text-[14px] sm:text-[12px] font-semibold text-[#94a3b8] dark:text-slate-500">
              Copyright &copy; 2023 - {tahunCopy} <span className="text-[#d98b41]">Komala Dewi</span>
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}
